export default __webpack_public_path__ + "static/media/battlestation.d3a8056d.svg";